import React, { useState } from "react";
import { Button, DropdownButton, Dropdown, DropdownItem, DropdownMenu} from "@deere/fuel-react";
import { SELF_SERVICE_STEPS, ADD_NEW_SECTION, PREVIOUS_BTN, NEXT_BTN, PUBLISH_BTN, SAVE_BTN, SELF_SERVICE_STEP_TITLES, DEFAULT_LANGUAGE_CODE, SELF_SERVICE_QUE_TYPES_GENERIC, SELF_SERVICE_QUE_TYPES_PART, LBL_HELP_DOC, NONE_PART_SECTION, PART_SECTION, SELFSERVICE_LANDING_PATH, SAVING, SAVE_SUCCESS, SURVEYPART_SECTION_TYPES, CRS_SURVEY_TEMPLATES } from "../../../utils/surveyLiterals";
import { useOktaAuth } from "@okta/okta-react";
import { saveSurveySelfService } from "../../../services/survey.service";
import { ModalSubmit } from "../../../components/ModalSubmit";
import { getHelpDocPdfBySurveyId, uploadHelpDoc } from "../../../services/surveyHelpDoc.service";
import { useTranslation } from "react-i18next";
import { ModalDocument } from "../../../components/modals/ModalDocument";
import { useLocation } from "react-router-dom";
import { useHistory } from 'react-router';
import { ERR_SAVE_SURVEY } from "../../../utils/errorLiterals";
import { expandMatrixDependentQuestions } from "../../../utils/matrixQuestionUtils";

const SelfServiceButtons = ({ activeStep, setActiveStep, addNewhandler, fnValidate, payloadData, setPayloadData, setCurrentLang, currentLang, isViewOnly, isPartTemplate, addNewParthandler, setLoader, showSubmitModal, setShowSubmitModal }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [currentLanguageCode, setCurrentLanguageCode] = useState( DEFAULT_LANGUAGE_CODE);
  const { authState } = useOktaAuth();
  const location = useLocation();
  const [showHelpDocModal, setShowHelpDocModal] = useState(false);
  const [docUrl, setDocUrl] = useState(null);
  const selfServiceQueTypes =  [...SELF_SERVICE_QUE_TYPES_GENERIC, ...SELF_SERVICE_QUE_TYPES_PART];
  const surveyStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.SURVEY_STEP);
  const languageStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.LANGUAGE_STEP);
  const titleTranslationStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.SURVEYTRANSLATION_STEP);
  const agreementId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.AGREEMENT_STEP);
  const sectionStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.SECTION_STEP);
  const questionStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.QUESTION_STEP);
  const helpDocStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.HELPDOCSTEP);
  const notificationStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.NOTIFICATION_EMAIL);
  const reportConfigurationStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.REPORT_CONFIGURATION_STEP);
  const reviewStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.REVIEW_STEP);
  const saveOrPublishStepId = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.SAVEORPUBLISH_STEP);

  const isPartTemplateSurvey = payloadData?.templateType === CRS_SURVEY_TEMPLATES.PART;
  const visibleSteps = SELF_SERVICE_STEPS.filter(
    (step) => step.title !== SELF_SERVICE_STEP_TITLES.REPORT_CONFIGURATION_STEP || isPartTemplateSurvey
  );
  const goToNextStep = () => {
    const currentIndex = visibleSteps.findIndex((step) => step.id === activeStep);
    if (currentIndex === -1) return;
    const nextStep = visibleSteps[currentIndex + 1];
    if (nextStep) setActiveStep(nextStep.id);
  };
  const goToPreviousStep = () => {
    const currentIndex = visibleSteps.findIndex((step) => step.id === activeStep);
    if (currentIndex === -1) return;
    const previousStep = visibleSteps[currentIndex - 1];
    if (previousStep) setActiveStep(previousStep.id);
  };


  const publishHandler = async (payload, methodCallFromSaveClick) => {
    try {
      if (methodCallFromSaveClick) 
        setLoader({isLoading: true, message: SAVING});
      const payloadRefined = refinePayloadData(payload)
      const surveyResponse = await saveSurveySelfService(payloadRefined, authState.accessToken.accessToken);
      const docsToUpload = payload.helpDocs.filter((hd) => hd.isNewUpload);
      if (docsToUpload.length > 0) await uploadHelpDoc(docsToUpload, surveyResponse.code, surveyResponse.templateRevision, authState.accessToken.accessToken);
      if (surveyResponse && surveyResponse.id) {
        if (payload.active) {//Publish
          setLoader({isLoading: false, message: ""});
          setShowSubmitModal(true);
        } else if (activeStep === saveOrPublishStepId.id) {//Save as Draft from last step
          history.push({
            pathname: "/selfServiceLanding",
            state: { previous: history?.location?.pathname },
          });
        } else {//Saving as Draft from intermediate step >> Show Success message for a few seconds
          updateUIPropertiesForQuestions(surveyResponse);
          surveyResponse.editSurvey = location?.state?.payloadData?.editSurvey ?? false; // Flag for revision
          if (methodCallFromSaveClick) {
            setLoader({isLoading: false, message: SAVE_SUCCESS});
            setTimeout(() => {
              setLoader({isLoading: false, message: ""});
            }, 1500);
          } else {
            goToNextStep();
          }
          setPayloadData(surveyResponse);
        }
      }
    } catch(err) {
      console.log(err);
      setLoader({isLoading: false, message: ERR_SAVE_SURVEY});
    }
  };

  const changeLanguage = languageCd => {
    setCurrentLang(languageCd);
  }

  const handleDefaultLangClick =(languageCd, e) =>{
    e.preventDefault();
    setCurrentLang(languageCd)
  }
  const updateUIPropertiesForQuestions = (survey) => {
    if (!survey?.sections) return survey;
    const qTypeMap = new Map(selfServiceQueTypes.map(type => [type.code, type]));
    survey.sections.forEach(section => {
      section.questions?.forEach(question => {
        const qType = qTypeMap.get(question.type);
        if (qType) {
          question.typeText = qType.type;
          question.needSelections = qType.needSelections;
        }
      });
    });
    return survey;
  };

  const refinePayloadData = (payloadData) => {
    const findQuestionForFilter = (filter) => {
      const questionCode = String(filter?.questionCode || filter?.key || "").trim();
      const questionId = filter?.questionId;

      const partQuestions = (payloadData?.sections || [])
        .filter((section) => section.type === SURVEYPART_SECTION_TYPES.PART)
        .flatMap((section) => section.questions || []);

      return partQuestions.find((q) => {
        const matchesByCode = questionCode !== "" && String(q?.code || "").trim() === questionCode;
        const matchesById = questionId !== undefined && questionId !== null
          && q?.id !== undefined && q?.id !== null
          && String(q.id) === String(questionId);
        return matchesByCode || matchesById;
      });
    };

    const buildFilterEntry = (filter, rawValue, selection) => ({
      ...(filter.reportConfigurationId ? { reportConfigurationId: filter.reportConfigurationId } : {}),
      ...(filter.questionId ? { questionId: filter.questionId } : {}),
      ...(filter.questionCode || filter.key ? { questionCode: filter.questionCode || filter.key } : {}),
      questionText: filter.questionText || filter.label,
      questionType: filter.questionType || filter.filterQuestionType || "",
      operatorCode: filter.operatorCode || "",
      value: String(rawValue),
      ...(selection?.id !== undefined && selection?.id !== null ? { selectionId: selection.id } : {}),
      ...(selection?.code ? { selectionCode: selection.code } : {}),
    });

    const buildFilterEntries = (filter) => {
      const filterQuestionType = filter?.questionType || filter?.filterQuestionType || "";

      if (filterQuestionType === "SELECT") {
        const selectedValues = Array.isArray(filter?.value) ? filter.value : (filter?.value ? [filter.value] : []);
        const question = findQuestionForFilter(filter);
        return selectedValues
          .filter((selectedValue) => String(selectedValue).trim() !== "")
          .map((selectedValue) => {
            const normalized = String(selectedValue).trim();
            const selection = (question?.selections || []).find((s) =>
              [s?.text, s?.code, s?.value].some((candidate) => String(candidate ?? "").trim() === normalized)
            );
            return buildFilterEntry(filter, selectedValue, selection);
          });
      }

      const rawValue = filter?.value;
      if (rawValue === undefined || rawValue === null || String(rawValue) === "") return [];
      return [buildFilterEntry(filter, rawValue)];
    };

    const reportConfiguration = payloadData?.reportConfiguration;
    const sectionsToInclude = reportConfiguration?.sectionsToInclude || [];
    const partSectionEnabled = sectionsToInclude.some((s) => s.type === SURVEYPART_SECTION_TYPES.PART && s.reportEnabled);
    const refinedReportConfiguration = reportConfiguration
      ? {
          ...(reportConfiguration.id ? { id: reportConfiguration.id } : {}),
          ...(reportConfiguration.surveyConfigurationId ? { surveyConfigurationId: reportConfiguration.surveyConfigurationId } : {}),
          enableReportGeneration: Boolean(reportConfiguration.enableReportGeneration),
          includeSignatureSection:
            reportConfiguration.includeSignatureSection ?? Boolean(reportConfiguration?.additionalElements?.signatureSection),
          includeDisclaimerSection:
            reportConfiguration.includeDisclaimerSection ?? Boolean(reportConfiguration?.additionalElements?.disclaimerAgreement),
          disclaimerMessage: reportConfiguration.disclaimerMessage ?? "",
          sectionsToInclude: sectionsToInclude.map((s) => ({
            ...(s.id ? { id: s.id } : {}),
            ...(s.sectionId != null ? { sectionId: s.sectionId } : {}),
            code: s.code,
            description: s.description || s.code,
            type: s.type,
            active: Boolean(s.active),
            reportEnabled: Boolean(s.reportEnabled),
            signatureSectionEnabled: Boolean(s.signatureSectionEnabled),
            ...(s.questionsToInclude ? {
              questionsToInclude: s.questionsToInclude.map((q) => ({
                ...(q.id != null ? { id: q.id } : {}),
                ...(q.columnMapping ? { columnMapping: q.columnMapping } : {
                  ...(q.questionId != null ? { questionId: q.questionId } : {}),
                  questionCode: q.questionCode,
                  questionText: q.questionText,
                  questionType: q.questionType,
                }),
                reportEnabled: Boolean(q.reportEnabled),
                ...(q.questionType === "MULTI_SEL" ? { columnToRow: Boolean(q.columnToRow) } : {}),
              }))
            } : {}),
          })),
          questionFilters: partSectionEnabled
            ? (reportConfiguration.questionFilters || [])
              .filter((filter) => filter.enabled !== false)
              .flatMap((filter) => buildFilterEntries(filter))
            : [],
        }
      : undefined;

    //Removing empty values from the payload
    return {
      ...payloadData,
      translations: payloadData.translations.filter((translation) => translation.text && translation.text !== ""),
      sections: expandMatrixDependentQuestions(payloadData.sections
        .filter((section) => section.description && section.description !== "")
        .map((section) => ({
          ...section,
          translations: section.translations.filter((translation) => translation.text && translation.text !== ""),
          questions: section.questions
            .filter((question) => question.text && question.text !== "")
            .map((question) => ({
              ...question,
              translations: question.translations.filter((translation) => translation.text && translation.text !== ""),
              selections: question.selections
                .filter((selection) => selection.text !== "")
                .map(({ point, longDescription, ...rest }) => ({ ...rest, translations: rest.translations.filter((translation) => translation.text && translation.text !== "") })),
            })),
        }))),
      helpDocs: payloadData.helpDocs ? payloadData.helpDocs.map(({ formData, ...rest }) => rest) : [], // Remove formData from helpDocs
      agreementPosition: payloadData.agreementData.length === 0 ? "" : payloadData.agreementPosition,
      ...(refinedReportConfiguration ? { reportConfiguration: refinedReportConfiguration } : {}),
    };
  };

  const helpDocFetcher = async () => {
    if (payloadData && payloadData.helpDocs) {
      const index = payloadData.helpDocs.findIndex((hd) => hd.languageCd === currentLang);
      const file = index > -1 && payloadData.helpDocs[index].formData ? payloadData.helpDocs[index].formData.get("file") : null;
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => setDocUrl(e.target.result);
        reader.readAsDataURL(file);
      } else if (payloadData.id) {
        try {
          const helpDocResponse = await getHelpDocPdfBySurveyId(authState.accessToken.accessToken, payloadData.id, currentLang, true);
          if (helpDocResponse.status === 200) {
            const blob = await helpDocResponse.blob();
            const url = window.URL.createObjectURL(blob);
            setDocUrl(url);
          }
        } catch (err) {
          console.log(err);
        }
      }
      setShowHelpDocModal(true);
    }
  };

  const NextButton = () => <Button variant="primary" className="ml-2" onClick={() => fnValidate(publishHandler)}>{NEXT_BTN}</Button>;
  const PreviousButton = () => <Button variant="secondary" onClick={goToPreviousStep}>{PREVIOUS_BTN}</Button>;
  const SaveButton = ({active}) => <Button variant="primary" className="ml-2" onClick={() => fnValidate ? fnValidate(publishHandler) : publishHandler(payloadData, true)} >{active ? PUBLISH_BTN : SAVE_BTN}</Button>;
  const AddSectionButton = () => isPartTemplate?
    <Dropdown>
      <DropdownButton variant="primary" style={{ width: "20%", margin: "0px auto 0px 0px" }}>{ADD_NEW_SECTION}</DropdownButton>
      <DropdownMenu>
        <DropdownItem onClick={addNewhandler}>{NONE_PART_SECTION}</DropdownItem>
        <DropdownItem onClick={addNewParthandler}>{PART_SECTION}</DropdownItem>
      </DropdownMenu>
    </Dropdown> 
    :
    <Button variant="primary" onClick={addNewhandler} style={{ width: "20%", margin: "0px auto 0px 0px" }}>{ADD_NEW_SECTION}</Button>;
  const HelpDocButton = () => payloadData.helpDocs.length > 0 && <Button variant="primary" onClick={helpDocFetcher} style={{ margin: "0px auto 0px 0px" }}>{LBL_HELP_DOC}</Button>;
  const LanguageMenu = () =>
    payloadData.language.length > 1 && (
      <Dropdown size="small">
        <DropdownButton onClick={(e) => e.preventDefault()} sx={{ marginRight: "10px" }}>
          {t("btn_change_language")}{" "}
        </DropdownButton>
        <DropdownMenu placement="top-start">
          {payloadData.language.map(({ languageCd, text }) =>
            currentLanguageCode === languageCd ? (
              <DropdownItem key={languageCd} href="#" className="nav-link active" onClick={(e) => handleDefaultLangClick(languageCd, e)}>
                <span className={`flag-icon  mx-2`} style={{ opacity: 0.3 }}></span>
                {text}
              </DropdownItem>
            ) : (
              <DropdownItem key={languageCd} href="#" onClick={() => changeLanguage(languageCd)}>
                <span className={`flag-icon  mx-2`} style={{ opacity: 1 }}></span>
                {text}
              </DropdownItem>
            )
          )}
        </DropdownMenu>
      </Dropdown>
    );

  const renderButtonsForSteps = () => {
    if (isViewOnly) {
      return <><HelpDocButton/><LanguageMenu /></>;
    }
    else {
      switch (activeStep) {
        case surveyStepId.id:
          return <NextButton />;
        case languageStepId.id:
        case titleTranslationStepId.id:
        case agreementId.id:
        case questionStepId.id:
        case helpDocStepId.id:
        case notificationStepId.id:
        case reportConfigurationStepId.id:
          return <><PreviousButton /><SaveButton /><NextButton /></>;
        case sectionStepId.id:
          return <><AddSectionButton /><PreviousButton /><SaveButton /><NextButton /></>;
        case reviewStepId.id:
          return <><HelpDocButton/><LanguageMenu /><PreviousButton /><NextButton /></>;
        case saveOrPublishStepId.id:
          return <><PreviousButton /><SaveButton active={payloadData && payloadData.active} /></>;
      }
    } 
  };

  return (
    <>
      {renderButtonsForSteps()}
      <ModalSubmit showModal={showSubmitModal} setShowModal={setShowSubmitModal} titleKey={"lbl_success"} messageKey={"lbl_survey_published"} buttonKey={"btn_OK"} navigateTo={SELFSERVICE_LANDING_PATH} />
      <ModalDocument showModal={showHelpDocModal} setShowModal={setShowHelpDocModal} labelBtnPrimary={t("btn_close")} titleModal={t("lbl_Help_Doc")} iFrameUrl={docUrl} />
    </>
  );
};

export default SelfServiceButtons;
